import React, { Component } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {imgError, logData, keyDownHandler, pasteHandler } from '../../utils/utils';
import {
  getAgentInfo,
  setAgentInfoData,
  uploadAvatar,
  modifyAgentInfo
} from '../../actions/getAgentConfig';
import noAvatar from '../../assets/img/no-avatar.png';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

const validFormats = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/svg'];

class EditPersonalDetailsModal extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    isShow: false,
  };

  componentWillReceiveProps = (nextProp) => {
    if (
      JSON.stringify(nextProp.agentInfo) !==
      JSON.stringify(this.props.agentInfo)
    ) {
      this.setState({
        name: nextProp.agentInfo.name ? nextProp.agentInfo.name : "",
        surname_1: nextProp.agentInfo.surname_1
          ? nextProp.agentInfo.surname_1
          : "",
        surname_2: nextProp.agentInfo.surname_2
          ? nextProp.agentInfo.surname_2
          : "",
        email: nextProp.agentInfo.email ? nextProp.agentInfo.email : "",
        address: nextProp.agentInfo.address ? nextProp.agentInfo.address : "",
        city: nextProp.agentInfo.city ? nextProp.agentInfo.city : "",
        zip: nextProp.agentInfo.zip ? nextProp.agentInfo.zip : "",
        province: nextProp.agentInfo.province
          ? nextProp.agentInfo.province
          : "",
        phone: nextProp.agentInfo.phone ? nextProp.agentInfo.phone : "",
        mobile_phone: nextProp.agentInfo.mobile_phone
          ? nextProp.agentInfo.mobile_phone
          : "",
          avatar:nextProp.agentInfo.avatar?nextProp.agentInfo.avatar:""
      });
    }
  };

  close = (key) => {
    this.setState(
      {
        showErr: false,
      },
      () => {
        this.props.handleClose(key);
      }
    );
  };
  // get data of agent
  getData = () => {
    this.setState(
      {
        imageToUpload: null,
        imagePreview: null,
        validFormat: true,
      },
      () => {
        this.props.getAgentInfo().then(
          () => {},
          (err) => {
            logData(err);
          }
        );
      }
    );
  };
  testString = (array, string) => {
    if (new RegExp(array.join("|")).test(string)) {
      return true;
    }
    return false;
  };
  // update state with input value
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  // closes alert
  handleAlertDismiss = () => {
    this.setState({
      showErr: false,
    });
  };

  handleFileClick = () => {
    document.getElementById("imageFile").click();
  };

  handleImageChange = (e) => {
    const imageToUpload = e.target.files;
    if (imageToUpload.length > 0) {
      const imgType = imageToUpload[0].type;
      // const validFormat = validFormatsRegex.test(imgType.toLowerCase());
      const validFormat = this.testString(validFormats, imgType.toLowerCase());
      this.setState(
        {
          showErr: false,
          validFormat,
          //invalidFormat: validFormats.indexOf(e.target.files[0].type.toLowerCase()) == -1
        },
        () => {
          if (!this.state.validFormat) {
            this.setState({
              errorMsg:
                this.props.translations.invalidImageFormat[
                  this.props.selectedLanguage
                ],
              showErr: true,
              imagePreview: "none",
            });
          } else {
            this.setState({
              imageToUpload,
              imagePreview: URL.createObjectURL(imageToUpload[0]),
            });
          }
        }
      );
    }
  };
handleAvatarUpload=()=>{
  this.props.uploadAvatar(this.state.imageToUpload[0], (data) => {
    this.setState({ uploading: false });
    if (!data.result)
      this.setState({
        errorMsg:
          data && data.error
            ? data.error
            : this.props.translations.commonErrorText[
                this.props.selectedLanguage
              ],
        showErr: true,
      });
    else this.setState({ avatar: data.response.items[0].avatar_url });
    this.handleDetailsSubmit();
  });
}
  handleImageUpload = () =>
    new Promise((resolve, reject) => {
      this.props.uploadAvatar(this.state.imageToUpload[0]).then(
        (res) => {
          this.setState({
            uploading: false,
          });
          if (!res || !res.data.result) {
            this.setState({
              errorMsg:
                res && res.data.description
                  ? res.data.description
                  : this.props.translations.commonErrorText[
                      this.props.selectedLanguage
                    ],
              showErr: true,
            });
            reject(false);
          } else {
            this.setState({avatar:res.data.response.items[0].avatar_url})
            resolve(true);
          }
        },
        () => {
          reject(false);
          this.setState({
            errorMsg:
              this.props.translations.commonErrorText[
                this.props.selectedLanguage
              ],
            showErr: true,
            uploading: false,
          });
        }
      );
    });
  // submits data
  handleSubmit = () => {
    const filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (this.state.name.length == 0 || this.state.email.length == 0) {
      // alert('Please enter all required fields');
      this.setState({
        errorMsg:
          this.props.translations.allFieldsRequired[
            this.props.selectedLanguage
          ],
        showErr: true,
      });
      return;
    } else if (!filter.test(this.state.email)) {
      this.setState({
        errorMsg:
          this.props.translations.emailInvalid[this.props.selectedLanguage],
        showErr: true,
      });
      return;
    } else {
      if (this.state.imageToUpload) {
        this.setState(
          {
            uploading: true,
          },
          () => {
            this.handleAvatarUpload();
            // this.handleImageUpload().then(() => {
            //   this.handleDetailsSubmit();
            // });
          }
        );
      } else {
        this.handleDetailsSubmit();
      }
    }
  };

  handleDetailsSubmit = () => {
    // makes api call from action
    //console.log('handle submint')
    this.props.setAgentInfoData(this.state).then(
      (res) => {
        if (res.data.result) {
          this.setState(
            {
              showErr: false,
            },
            () => {
              this.props.handleClose(this.props.showEditDetailsModal);
              this.getData();
            }
          );
        } else {
          this.setState({
            errorMsg:
              res.data.description ||
              this.props.translations.commonErrorText[
                this.props.selectedLanguage
              ],
            showErr: true,
          });
        }
      },
      (err) => {
        logData(err);
        this.setState({
          errorMsg:
            this.props.translations.commonErrorText[
              this.props.selectedLanguage
            ],
          showErr: true,
        });
      }
    );
  };

  render() {
    const { uploading, imagePreview, validFormat } = this.state;
    const { translations, selectedLanguage, agentInfo } = this.props;
    //console.log(agentInfo);
    return (
      <Modal
        dialogClassName="redirectModal"
        onEnter={this.getData}
        show={this.props.showEditDetailsModal}
        onHide={() => this.close("showEditDetailsModal")}
        backdrop="static"
      >
        <Modal.Header
          className={`modal-content${this.props.theme} modal-header${this.props.theme}`}
          closeButton
        >
          <Modal.Title>
            {translations.personalData[selectedLanguage]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={`modal-content${this.props.theme}`}
          style={{ overflow: "auto" }}
        >
          {this.state.showErr && (
            <div className="alertWrapper">
              <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                <p>{this.state.errorMsg}</p>
              </Alert>
            </div>
          )}
          <div className="row">
            <div style={{ width: 100, float: "left", paddingLeft: 15 }}>
              <img
                className={uploading ? "img_loading_anim" : ""}
                src={imagePreview ? imagePreview : agentInfo.avatar || noAvatar}
                onError={imgError}
                height="76"
                width="76"
                style={{ cursor: "pointer" }}
                onClick={this.handleFileClick}
              />
              <input
                type="file"
                name="image"
                id="imageFile"
                accept="image/*"
                onChange={this.handleImageChange}
                style={{ display: "none" }}
              />
            </div>
            <div style={{ width: "calc(100% - 100px)", float: "left" }}>
              <div className="col-md-4">
                <div className="form-group required">
                  <label htmlFor="exampleInputEmail1" className="control-label">
                    {translations.name[selectedLanguage]}
                  </label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                    value={this.state.name}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="control-label">
                    {translations.surname1[selectedLanguage]}
                  </label>
                  <input
                    type="text"
                    name="surname_1"
                    className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                    id="exampleInputEmail1"
                    value={this.state.surname_1}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="control-label">
                    {translations.surname2[selectedLanguage]}
                  </label>
                  <input
                    type="text"
                    name="surname_2"
                    className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                    id="exampleInputEmail1"
                    value={this.state.surname_2}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.address[selectedLanguage]}
                </label>
                <input
                  type="text"
                  name="address"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  value={this.state.address}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.postalCode[selectedLanguage]}
                </label>
                <input
                  type="text"
                  onKeyDown={(event) =>
                    keyDownHandler(event, "allowOnlyNumbers")
                  }
                  onPaste={(event) => pasteHandler(event, "allowOnlyNumbers")}
                  name="zip"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  value={this.state.zip}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.city[selectedLanguage]}
                </label>
                <input
                  type="text"
                  name="city"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  value={this.state.city}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.province[selectedLanguage]}
                </label>
                <input
                  type="text"
                  name="province"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  value={this.state.province}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group required">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.email[selectedLanguage]}
                </label>
                <input
                  type="email"
                  name="email"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  id="exampleInputEmail1"
                  value={this.state.email}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.phoneNumber1[selectedLanguage]}
                </label>
                <input
                  type="text"
                  onKeyDown={(event) =>
                    keyDownHandler(event, "allowNumbersAndChars")
                  }
                  onPaste={(event) =>
                    pasteHandler(event, "allowNumbersAndChars")
                  }
                  name="phone"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  value={this.state.phone}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="control-label">
                  {translations.phoneNumber2[selectedLanguage]}
                </label>
                <input
                  type="text"
                  onKeyDown={(event) =>
                    keyDownHandler(event, "allowNumbersAndChars")
                  }
                  onPaste={(event) =>
                    pasteHandler(event, "allowNumbersAndChars")
                  }
                  name="mobile_phone"
                  className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                  value={this.state.mobile_phone}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close("showEditDetailsModal")}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
          >
            {translations.cancel[selectedLanguage]}
          </button>
          <button
            onClick={this.handleSubmit}
            type="submit"
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
            disabled={uploading || !validFormat}
          >
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    agentConfig: state.agentConfig,
    agentInfo: state.agentInfo,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { getAgentInfo, setAgentInfoData, uploadAvatar, modifyAgentInfo },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPersonalDetailsModal);


// WEBPACK FOOTER //
// ./src/agent/modals/editPersonalDetails.js